export const tones = ['Conversational', 'Enthusiastic', 'Humorous', 'Professional']
